export default {
  talksPageContainer: {
    display: 'flex',
    height: 'calc(100vh - 40px)',
  },
  talksPageRightCol: {
    width: '40%',
    display: 'flex',
    justifyContent: 'space-between',
    height: 'calc(100% - 10px)',
    overflow: 'auto',
    padding: '5px',
  },
  talksPageChat: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '49%',
    height: '100%',
    padding: '0',
    flexShrink: '0',
  },
  talksPageUnreadMsgLine: {
    width: '100%',
    marginBottom: '10px',
    textAlign: 'center',
    padding: '5px 0',
    background: 'pink',
  },
  talksPageContactSelectLink: {
    display: 'block',
    padding: '6px 16px',
    fontSize: '13px',
    color: 'black',
    background: '#fff',
  },
  talksPageContactSelectLinkSelected: {
    color: '#fff',
    background: '#419FD9',
  },
  talksPageContactSelectText: {
    margin: '5px 0px 0 5px',
    fontSize: '17px',
  },
  '@media (max-width: 900px)': {
    talksPageContainer: {
      height: 'auto',
      flexDirection: 'column',
    },
    talksPageChat: {
      width: 'auto',
    },
    talksPageContactSelect: {
      flexShrink: '0',
      background: '#fff',
      margin: '5px 5px 0px 5px',
      paddingLeft: '5px',
    },
    talksPageContactSelectFocused: {
      '&:focus': {
        background: 'transparent',
      },
    },
    talksPageRightCol: {
      width: '100%',
    },
  },
};
